import http from "../requestBase";
import LocationTranslation from "./LocationTranslation";

/**
 * @typedef {string} GUID
 */
/**
 * @typedef {Object} Location
 * @property {number} ClientId
 * @property {string} LocationStoreId
 * @property {string} LocationName
 * @property {string} LocationStatusId
 */

//api/SurveyInstanceHistory/{SurveyInstanceGuid}
const API_BASE = "/api/Locations";
const API_HIST = "api/LocationHistory";

/**
 * Gets all location Paginated
 * @param {Object} filterStrings Contains the Columms as key and the filter as values
 * @param {Number} pageSize Items per page
 * @param {Number} selectedPage The Selected Field
 * @param {String} sortField The Field to sort by
 * @param {('asc'|'desc')} [sortOrder]  Sort order
 * @returns {Promise<import('axios').AxiosResponse<Location[]>}
 * @re
 */
function getAll(
  filterStrings,
  pageSize = 20,
  selectedPage = 1,
  sortField = "LocationName",
  sortOrder = "asc"
) {
  let queryString = `${API_BASE}/Get?page_size=${pageSize}&page=${selectedPage}&sort_column=${sortField}&sort_order=${sortOrder}`;
  queryString = encodeURI(queryString);

  //TODO: validate Filter and trim
  let Filter = _.isEmpty(filterStrings) ? "" : filterStrings;

  return http.post(queryString, { Filter });
}

/**
 * Gets a singel Location
 * @param {number} id
 * @returns {Promise<import('axios').AxiosResponse<Location>}
 */
function getById(id) {
  return http.get(`${API_BASE}/${id}`);
}

/**
 *
 * @param {Location} content
 * @returns {Promise<import('axios').AxiosResponse<any[]>}
 */
function create(content) {
  return http.post(`${API_BASE}`, content);
}

/**
 * Update a single Location
 * @param {number} id The Location id you want to update
 * @param {Location} content The new Location data
 */
function update(id, content) {
  return http.put(`${API_BASE}/${id}`, content);
}

/**
 * Delete a single Location
 * @param {number} id The id of the Location you want to delete
 */
function deleteByID(id) {
  return http.delete(`${API_BASE}/${id}`);
}

/**
 * Fetch the History of a single Location
 * @param {GUID} id - The Location GUID
 */
function getHistoryByGUID(GUID) {
  return http.get(`${API_HIST}/${GUID}`);
}
/**
 * Create a Translation for a given Location
 * @param {GUID} guid
 */
function createTranslation(guid, data) {
  return http.post(`${API_BASE}/${guid}/Translations`, data);
}
/**
 * Get all the Translation for a given Location
 * @param {GUID} guid
 * @returns
 */
function getTranslation(guid) {
  return http.get(`${API_BASE}/${guid}/Translations`);
}

let UseLocation = {
  getAll,
  getById,
  create,
  update,
  deleteByID,
  getHistoryByGUID,
  Translations: {
    create: createTranslation,
    update: LocationTranslation.update,
    delete: LocationTranslation.deleteByGuid,
    getAll: getTranslation,
  },
};

export default UseLocation;



// WEBPACK FOOTER //
// ./src/services/Locations/index.js